export const listMutations = <const>{
	JINY_PLATCE_FILTER_SELECT_MAPPER: 'jinyPlatceFilterSelectMapper',
	PRACOVNIK_FILTER_SELECT_MAPPER: 'pracovnikFilterSelectMapper',
	LEASING_FILTER_SELECT_MAPPER: 'leasingFilterSelectMapper',
	POISTOVNA_FILTER_SELECT_MAPPER: 'poistovnaFilterSelectMapper',
	PRODEJCEPR_FILTER_SELECT_MAPPER: 'prodejceprFilterSelectMapper',
};

export const listActions = <const>{

};
